<template>
  <div class="rating">
    <HeaderFilters />
    <CardListDropdown
      v-model="activeCard"
      :loading="isLoadingAnalytics"
      :card-list="cardList"
      :width="4"
    />
    <ChartList />
    <SpeedHundredTable
      :sort-chanel="filter.sort.channelId"
      :nav-titles="navTitles"
      :tabs="tableTabs"
      :current-tab="currentTableTab"
      @tabChanged="onTabChanged($event)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SpeedHundredTable from './components/SpeedHundredTable';
import ChartList from './components/ChartList';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';
import CardListDropdown from '../components/CardListDropdown';
import HeaderFilters from './components/HeaderFilters';
import numberFormat from '@/filters/numberFormat.filter';

export default {
  components: {
    SpeedHundredTable,
    CardListDropdown,
    ChartList,
    HeaderFilters
  },
  data: () => ({
    isShowModal: false,
    activeCard: null,
    filter: {
      course: '',
      amoProduct: '',
      budgetMin: null,
      budgetMax: null,
      revenueMin: null,
      revenueMax: null,
      report: 'team',
      sort: {
        channelId: null,
        // 0 - DESC; 1 - ASC
        sortType: null,
        sortName: null
      }
    },
    tableTabs: [
      {
        id: 0,
        title: 'Команды',
        slug: 'teams'
      },
      {
        id: 1,
        title: 'Капитаны',
        slug: 'capitan'
      },
      {
        id: 2,
        title: 'Факультеты',
        slug: 'faculty'
      },
      {
        id: 3,
        title: 'Ответственные',
        slug: 'responsible'
      }
    ],
    currentTableTab: {
      id: 0,
      title: 'Команды',
      slug: 'teams'
    },
    navTitles: [
      {
        title: 'Название команды',
        id: 1,
        width: '3fr'
      },
      {
        title: 'Заполняемость',
        id: 2,
        width: '2fr',

        channelId: 2,
        sortType: 0,
        sortName: 'fillable'
      },
      {
        title: 'Выручка на 1уч.',
        id: 3,
        width: '1fr',

        channelId: 0,
        sortType: 0,
        slider: {
          channelId: 3,
          open: false,
          sortType: 0
        },
        sortName: 'revenueToOne'
      },
      {
        title: 'Прибыль на 1уч.',
        id: 4,
        width: '1fr',

        channelId: 1,
        sortType: 0,
        slider: {
          channelId: 4,
          open: false,
          sortType: 0
        },
        sortName: 'profitToOne'
      }
    ]
  }),
  computed: {
    ...mapState('auth', {
      isAdmin: s => s.data.user.permissions.isAdmin,
      user: s => s.data.user,
      isLoadingUser: s => s.meta.loading
    }),
    ...mapState('ratingSpeedAndHundred', {
      totalCount: s => s.data.totalCount,
      currentWeek: s => s.data.currentWeek,
      profitInc: s => s.data.profitInc,
      revenueInc: s => s.data.revenueInc,
      isLoadingAnalytics: s => s.meta.isLoadingAnalytics
    }),
    cardList() {
      return [
        {
          id: 0,
          icon: 'teams-square',
          title: 'Участники',
          value: this.totalCount,
          iconRight: true
        },
        {
          id: 2,
          icon: 'calendar-square',
          title: 'Неделя',
          value: this.currentWeek,
          iconRight: true
        },
        {
          id: 3,
          icon: 'wallet-square',
          title: 'Средний прирост по выручке',
          value:
            (this.revenueInc
              ? this.getFormattedValue(this.revenueInc.rub)
              : 0) +
            ' руб / ' +
            (this.revenueInc ? this.revenueInc.percent : 0) +
            '%',
          class: '-l- -pointer-',
          iconRight: true,
          canOpen: true,
          openValue: this.revenueInc ?? null
        },
        {
          id: 4,
          icon: 'money-bug-square',
          title: 'Средний прирост по прибыли',
          value:
            (this.profitInc ? this.getFormattedValue(this.profitInc.rub) : 0) +
            ' руб / ' +
            (this.profitInc ? this.profitInc.percent : 0) +
            '%',
          class: '-l- -pointer-',
          iconRight: true,
          canOpen: true,
          openValue: this.profitInc ?? null
        }
      ];
    }
  },
  watch: {
    '$route.query'() {
      this.getUsersList();
      this.getAnalyticsData();
    }
  },
  mounted() {
    this.setupTabs();
    this.getAnalyticsData();
    this.getUsersList();
  },
  destroyed() {
    this.$store.dispatch('ratingSpeedAndHundred/clearUserList');
  },
  methods: {
    ...mapActions('ratingSpeedAndHundred', [
      'getAnalyticsData',
      'getUsersList'
    ]),
    openUser(id) {
      this.$router.push(`/rating/unified/user/${id}`);
    },
    getFormattedValue(value) {
      return numberFormat(value, this.noDot);
    },
    setupTabs() {
      if (this.$route.query['report']) {
        this.currentTableTab = this.tableTabs.find(
          t => t.slug === this.$route.query['report']
        );
      } else {
        this.changeValue('teams', 'report');
      }
    },
    onTabChanged(tabId) {
      this.currentTableTab = this.tableTabs.find(t => t.id === tabId);
      switch (this.currentTableTab.slug) {
        case 'teams':
          this.navTitles[0].title = 'Название команды';
          break;
        case 'capitan':
          this.navTitles[0].title = 'Капитан';
          break;
        case 'faculty':
          this.navTitles[0].title = 'Название факультета';
          break;
        case 'responsible':
          this.navTitles[0].title = 'Город';
          break;
      }
      this.changeValue(this.currentTableTab.slug, 'report');
    },
    changeValue(value, name) {
      const obj = {};
      obj[name] = value;

      const arrQuery = Object.entries({ ...this.$route.query, ...obj }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }

      replaceRouteQuery(arrQuery);
    },
    multipleChangeValue(params) {
      const arrQuery = Object.entries({ ...this.$route.query, ...params }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }
      replaceRouteQuery(arrQuery);
    },
    checkRouterEqual(arrQuery) {
      return !arrQuery.find(
        param => param.value != this.$route.query[param.name]
      );
    }
  }
};
</script>

<style></style>
